import React, { useState, useEffect } from "react";
import { Button, FormControl, InputAdornment, OutlinedInput, Grid, Checkbox, Dialog, DialogContent } from "@mui/material";
import { images, taskAssign } from "../../config/images";  // Assuming these images exist in your config
import translations from "../../config/language";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { changePassword, updatePassword } from "../../config/services";

const ChangePasswordPopup = ({ isOpen, onClose, onConfirm, loading, setLoading, id }) => {
  // Always call hooks at the top level

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };


  const [formValues, setFormValues] = useState({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };


  const handleTogglePasswordVisibility = (field) => {
    if (field === "old") {
      setShowOldPassword(!showOldPassword);
    } else if (field === "new") {
      setShowNewPassword(!showNewPassword);
    } else if (field === "confirm") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  const [lengthValid, setLengthValid] = useState(false);
  const [numberValid, setNumberValid] = useState(false);
  const [specialCharValid, setSpecialCharValid] = useState(false);
  const [lowercaseValid, setLowercaseValid] = useState(false);
  const [uppercaseValid, setUppercaseValid] = useState(false);

  useEffect(() => {
    // Check password length

    if (
      formValues.newPassword.length >= 8 &&
      formValues.newPassword.length <= 16
    ) {
      setLengthValid(true);
    } else {
      setLengthValid(false);
    }

    // Check for number
    const numberRegex = /\d/;
    if (numberRegex.test(formValues.newPassword)) {
      setNumberValid(true);
    } else {
      setNumberValid(false);
    }

    // Check for special character
    const specialCharRegex = /[^\w\s]/;
    if (specialCharRegex.test(formValues.newPassword)) {
      setSpecialCharValid(true);
    } else {
      setSpecialCharValid(false);
    }

    // Check for lowercase letter
    const lowercaseRegex = /[a-z]/;
    if (lowercaseRegex.test(formValues.newPassword)) {
      setLowercaseValid(true);
    } else {
      setLowercaseValid(false);
    }

    // Check for uppercase letter
    const uppercaseRegex = /[A-Z]/;
    if (uppercaseRegex.test(formValues.newPassword)) {
      setUppercaseValid(true);
    } else {
      setUppercaseValid(false);
    }

  }, [formValues.newPassword]);



  const handleChangePassword = async () => {
    if (!formValues.newPassword) {
      notify("Please enter password in both field.");
      return true;
    }
    if (!formValues.confirmNewPassword) {
      notify("Please enter password in both field.");
      return true;
    }

    if (
      !lengthValid ||
      !numberValid ||
      !specialCharValid ||
      !lowercaseValid ||
      !uppercaseValid
    ) {
      return true;
    }

    if (formValues.newPassword !== formValues.confirmNewPassword) {
      notify("Please check password is not same.");
      return;
    }
    const params = {
      old_password: formValues.oldPassword,
      new_password: formValues.newPassword,
      confirm_password: formValues.confirmNewPassword,
    }
    try {
      setLoading(true);

      const resp = await changePassword(id, params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        handleClose();
        onConfirm();
      }

    } catch (error) {
      console.log("error", error);
      notify(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      handleClose();
    }


  };

  const handleClose = () => {
    setFormValues({
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    onClose();
  };

  // Return null if the popup is not open
  if (!isOpen) return null;

  return (
    <>
      <Dialog open={isOpen}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <div className="assign-div">
          {" "}
          <div className="d-flex justify-content-around align-items-center">
            <h5
              className="p-3 mb-0"
              style={{ textAlign: "center", marginLeft: "70px" }}
            >
              {/* {translations} */}
              Change Password
            </h5>
            <img
              src={taskAssign.closeIcon}
              alt=""
              style={{
                height: "30px",
                width: "30px",
                cursor: "pointer",
                marginLeft: "95px",
              }}
              onClick={() => handleClose()}
            />
          </div>

        </div>
        <DialogContent>
          {/* Old Password Input */}
          <FormControl fullWidth className="mb-3" sx={{ m: 1 }} variant="outlined">
            <OutlinedInput
              id="old-password"
              type={showOldPassword ? 'text' : 'password'}
              value={formValues.oldPassword}
              onChange={handleChange}
              name="oldPassword"
              startAdornment={
                <InputAdornment position="start">
                  <img src={images.viewPassword} className="input-logo" alt="view" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <img
                    src={images.viewIcon}
                    onClick={() => handleTogglePasswordVisibility("old")}
                    className="input-logo"
                    style={{ cursor: "pointer" }}
                    alt="toggle visibility"
                  />
                </InputAdornment>
              }
              placeholder="Old Password"
            />
          </FormControl>

          {/* New Password Input */}
          <FormControl fullWidth className="mb-3" sx={{ m: 1 }} variant="outlined">
            <OutlinedInput
              id="new-password"
              type={showNewPassword ? 'text' : 'password'}
              value={formValues.newPassword}
              onChange={handleChange}
              name="newPassword"
              startAdornment={
                <InputAdornment position="start">
                  <img src={images.viewPassword} className="input-logo" alt="view" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <img
                    src={images.viewIcon}
                    onClick={() => handleTogglePasswordVisibility("new")}
                    className="input-logo"
                    style={{ cursor: "pointer" }}
                    alt="toggle visibility"
                  />
                </InputAdornment>
              }
              placeholder="New Password"
            />
          </FormControl>

          {/* Confirm New Password Input */}
          <FormControl fullWidth className="mb-3" sx={{ m: 1 }} variant="outlined">
            <OutlinedInput
              id="confirm-new-password"
              type={showConfirmPassword ? 'text' : 'password'}
              value={formValues.confirmNewPassword}
              onChange={handleChange}
              name="confirmNewPassword"
              startAdornment={
                <InputAdornment position="start">
                  <img src={images.viewPassword} className="input-logo" alt="view" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <img
                    src={images.viewIcon}
                    onClick={() => handleTogglePasswordVisibility("confirm")}
                    className="input-logo"
                    style={{ cursor: "pointer" }}
                    alt="toggle visibility"
                  />
                </InputAdornment>
              }
              placeholder="Confirm New Password"
            />
          </FormControl>

          <button
            className="assign-task-button mt-2"
            onClick={() => handleChangePassword()}>
            {loading ? <span className="spinner"></span> : "Confirm"}
          </button>
        </DialogContent>

      </Dialog>
    </>
  );
};

export default ChangePasswordPopup;
